export default __webpack_public_path__ + "static/media/pork.0ce295f8.png";